import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    // ✅ Load user from localStorage when component mounts
    useEffect(() => {
        const storedUser = localStorage.getItem("sun_user");
        const expiration = localStorage.getItem("sun_user_expiration");

        if (storedUser && expiration) {
            const now = new Date().getTime();
            if (now < parseInt(expiration, 10)) {
                setUser(JSON.parse(storedUser)); // ✅ Restore session
            } else {
                localStorage.removeItem("sun_user"); // ✅ Expired, remove
                localStorage.removeItem("sun_user_expiration");
            }
        }
    }, []);

    // ✅ Store user in localStorage and set expiration (24 hours)
    const login = (userData) => {
        const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours

        // Save complete user data for session restoration
        const sessionData = {
            role: userData.role,
            userId: userData.userId,
            bettingShops: userData.bettingShops,
            bettingShopId: userData.bettingShopId,
            loginTime: new Date().getTime()
        };

        localStorage.setItem("sun_user", JSON.stringify(sessionData));
        localStorage.setItem("sun_user_expiration", expirationTime.toString());

        setUser(sessionData);
    };

    // ✅ Logout & clear storage
    const logout = () => {
        // Clear session data
        localStorage.removeItem("sun_user");
        localStorage.removeItem("sun_user_expiration");
        
        // Clear all user-related data
        localStorage.removeItem("sun_bettingShopId");
        localStorage.removeItem("sun_userId");
        localStorage.removeItem("sun_userRole");
        localStorage.removeItem("sun_bettingShopsList");
        
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
